<template>
  <section v-bind:class="{
    fontLoaded,
    'voting-disabled': !votingEnabled || !isVoteable,
    'has-voted': votingComplete
  }">
    <transition appear name="feedback-block" @after-enter="onAfterEnter">
      <div class="form-ask-inner">
        <a href="#" class="form-ask-fake" @click="expandTextarea" v-show="!isShow">
          Click to start typing your answer...
        </a>
        <transition appear name="feedback">
          <div class="form-group form-group-q mb-0">
            <textarea class="form-control form-area form-question form-counted"
                      v-bind:class="{
                        'bigger-textarea': isShow
                      }"
                      placeholder="Click to start typing..."
                      data-inputlength="100" spellcheck="false"
                      ref="feedback"
                      v-model="feedback"
                      :disabled="votingComplete"
                      aria-label="Type your answer"
            >
            </textarea>
            <span class="counter" v-bind:class="{'invalid-counter': charactersLeft < 0}">{{charactersLeft}}</span>
          </div>
        </transition>
      </div>
    </transition>
    <div class="button-wrap">
      <transition appear :name="'button'">
        <VoteButton v-if="loaded && (pollGroupModeActive || !resetEnabled)" :onVote="onVote" />
      </transition>
      <ResetButton v-if="votingComplete && resetEnabled" />
      <NextButton v-if="pollGroupModeActive && (votingComplete || WEBCanSkip || isTimerEnded)" />
      <StoryButton v-if="votingComplete && WEBNextType === 'storyLink'" />
    </div>
  </section>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex';

import VoteButton from './VoteButton';
import NextButton from './NextButton';
import StoryButton from './StoryButton';
import ResetButton from './ResetButton';

export default {
  name: 'Feedback',
  components: {
    ResetButton,
    VoteButton,
    NextButton,
    StoryButton
  },
  data() {
    return {
      vote: () => {},
      isShow: false
    };
  },
  computed: {
    ...mapState('poll', [
      'votingEnabled',
      'votingComplete',
      'showMultiVote',
      'WEBResultsEnabled',
      'loaded',
      'fontLoaded',
      'WEBNextType',
      'WEBCanSkip',
      'resetEnabled',
      'pollType'
    ]),
    ...mapGetters('poll', [
      'isVoteable',
      'getFeedback',
      'isTimerEnded',
      'nextLink'
    ]),
    ...mapGetters('pollGroup', [
      'pollGroupModeActive',
      'hasNextPoll',
      'leaderboardEnabled'
    ]),
    feedback: {
      get() {
        return this.getFeedback;
      },
      set(value) {
        this.setFeedback(value);
      }
    },
    charactersLeft() {
      const characterCount = this.pollType === 'qa' ? +process.env.VUE_APP_MAX_OE_CHARACTERS : +process.env.VUE_APP_MAX_WC_CHARACTERS;
      const count = characterCount - this.feedback.length;
      count < 0 || count === characterCount ? this.disableVoting() : this.enableVoting();
      return count;
    },
    hasLeaderBoard() {
      return (this.pollGroupModeActive && (this.WEBNextType === 'leaderboard' && this.leaderboardEnabled));
    },
    displayNext() {
      return (this.votingComplete || this.isTimerEnded) && this.showTimer;
    }
  },
  methods: {
    ...mapMutations('poll', [
      'setFeedback',
      'disableVoting',
      'enableVoting'
    ]),
    ...mapActions('pollGroup', [
      'nextPoll'
    ]),
    ...mapActions('voter', [
      'switchView'
    ]),
    expandTextarea(e) {
      e.preventDefault();
      this.isShow = !this.isShow;
      this.$refs.feedback.focus();
    },
    onAfterEnter() {
      this.$emit('on-feedback-loaded');
    },
    onVote() {
      if (this.displayNext) {
        return;
      }

      if (this.pollGroupModeActive) {
        this.hasNextPoll ? this.nextPoll() : this.switchView('congratulations');
      } else if (this.nextLink) {
        window.location.href = this.nextLink;
      }
    }
  }
}
</script>

<style scoped lang="scss">
section {
  flex: 0 0 auto;
  margin: 24px auto 0;
  width: 100%;
  z-index: 100;
}
.swpoll {
  -webkit-perspective: 5000px;
  perspective: 5000px;
  height: 100vh;
  position: relative;
}

.swpoll-content {
  padding: 0 var(--padding-hor-mob);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100%;
}

@media only screen and (min-width: 650px) {
  .swpoll-content {
    max-width: var(--content-block-width);
    margin: 0 auto;
  }
}

@media only screen and (min-width: 768px) {
  .swpoll-content {
    padding: 0 var(--padding-hor);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    max-height: 100vh;
    .swpoll-body {
      width: 100%;
      -webkit-box-flex: 0;
      -ms-flex: 0 1 auto;
      flex: 0 1 auto;
      overflow-y: auto;
    }
  }
}

.swpoll-vote {
  display: flex;
  align-items: center;
  position: relative;
  color: var(--answer-color);
  box-shadow: inset 0 0 0 var(--answer-borderwidth) var(--answer-bordercolor);
  background-color: var(--answer-bg);
  transition: transform 900ms cubic-bezier(0.230, 1.000, 0.320, 1.000),
  box-shadow 350ms cubic-bezier(0.230, 1.000, 0.320, 1.000);
  border-radius: var(--answer-radius);
  padding: var(--answer-padding-ver) var(--answer-padding-hor);
  text-decoration: none !important;
  margin-bottom: var(--answer-bottommargin);
  transition: .3s ease-out;
  transform: scale(1);
  opacity: 1;
  backdrop-filter: blur(4px);
  min-height: var(--answer-min-height);
  cursor: pointer;

  &:hover {
    .swimg {
      transform: scale(1.1);
      transition-delay: 0s;
    }
  }

  p {
    margin: 0;
  }

  .text {
    padding-right: 50px;
    flex: 1 1 auto;
    position: relative;
    z-index: 1;
    opacity: 0;

    p {
      font-size: var(--answer-fontsize);

      span {
        display: inline;

        &.animateLetter {
          animation: letterPop ease-in-out .35s;
          animation-iteration-count: 1;
          animation-fill-mode: forwards;
          position: relative;
        }
      }
    }
  }

  .swpoll-check {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    width: 24px;
    height: 24px;
    border: 1px solid rgba(255,255,255,.8);
    border-radius: 4px;
    position: relative;
    z-index: 2;
    flex: 0 0 auto;

    input {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }

    svg {
      width: 65%;
      height: auto;
      transition: all 500ms cubic-bezier(0.175, 0.885, 0.320, 1.275);
      opacity: 0;
      transform: scale(.2);

      g {
        stroke: var(--button-bg);
      }
    }
  }

  .swbar {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: var(--answer-radius);
    overflow: hidden;
    transition: all 750ms cubic-bezier(0.22, 1, 0.36, 1);

    .swbar-bar {
      background: var(--result-bar-bg);
      position: absolute;
      left: 0;
      top: 0;
      width: 0;
      transition: all 750ms cubic-bezier(0.22, 1, 0.36, 1);
      height: 100%;
      opacity: 0;
      visibility: hidden;
    }
  }

  .swperc {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    opacity: 0;
    transition: all 750ms cubic-bezier(0.22, 1, 0.36, 1);
    visibility: hidden;
    z-index: 1;
  }

  .swimg {
    width: var(--answer-img-width);
    height: var(--answer-img-height);
    border-radius: var(--answer-img-radius);
    overflow: hidden;
    margin: -2px;
    margin-left: -10px;
    margin-right: 14px;
    flex: 0 0 auto;
    transition: all 2500ms cubic-bezier(0.22, 1, 0.36, 1);
    transform: scale(1);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &:hover,
  &:active {
    color: var(--answer-color);
    box-shadow: inset 0 0 0 var(--answer-borderwidth) transparent, 0 0 0 3px var(--answer-bordercolor);
  }
  &.selected {
    color: var(--answer-active);
    box-shadow: none;
    &:focus {
      color: var(--answer-active);
    }

    .swbar {
      background-color: var(--answer-bg-active);
    }

    .swpoll-check {
      background-color: rgba(255,255,255,.95);
      svg {
        opacity: 1;
        transform: scale(1);
      }
    }
  }
  &:focus {
    color: var(--answer-color);
  }
}

.voting-disabled {
  .swpoll-vote {
    pointer-events: none;
  }
}
.form-group-q {
  display: block;
  position: relative;
  z-index: 2;
}

.form-group-q {
  .counter {
    background-color: rgba(0, 0, 0, 0.15);
    color: #fff;
    display: inline-block;
    padding: 1px 5px;
    border-radius: 2px;
    position: absolute;
    right: 1px;
    top: 1px;
    font-size: 11px;
    min-width: 24px;
    text-align: center;
  }

  .invalid-counter {
    background-color: #ff0000de;
  }

  .form-question {
    height: 20px;
    font-size: 16px !important;
    border: none;
    transition: height 0.3s ease-in;
  }
  .form-question:disabled {
    background-color: white;
    color: var(--form-placeholder-color);
  }
  .form-area {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    resize: vertical;
  }
  .form-control {
    font-family: var(--font);
    font-size: 1rem;
    color: var(--form-color);
    border-radius: var(--form-radius);
    border-color: transparent;
    padding: 0 12px 12px;
    margin-top: 15px;
    width: 100%;
  }
  .form-control:focus {
    outline: none;
    border-color: #fff;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .form-control::-webkit-input-placeholder {
    color: #fff;
  }
  .form-control:-ms-input-placeholder {
    color: #fff;
  }
  .form-control::-ms-input-placeholder {
    color: #fff;
  }
  .form-control::placeholder {
    color: #fff;
  }
  .form-name {
    padding: 8px 15px;
    border: none;
  }
  .btn-primary {
    font-size: .9em;
    background-color: var(--success-color);
    border: none;
    padding: 12px 20px;
    line-height: 1em;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    min-width: 80px;
  }
  .btn-primary:active {
    background-color: var(--success-color) !important;
  }
  .btn-primary:hover {
    background-color: var(--success-color) !important;
  }
}

@media only screen and (max-width: 767px) {
  .form-group-q .form-control {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-left: none;
    border-right: none;
    padding-left: 15px;
    font-size: .9rem;
  }
}

.form-ask-fake {
  padding: 16px 15px;
  border-radius: 4px;
  color: var(--form-placeholder-color);
  margin-bottom: -1px;
  -webkit-transition: .2s color;
  transition: .2s color;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  line-height: 1.1em;
  text-decoration: none;
  text-align: left;
  z-index: 100;
  background: white;
}
.form-ask-fake:hover {
  text-decoration: none;
  color: var(--form-placeholder-color);
}
@media only screen and (max-width: 767px) {
  .form-ask-fake {
    border-radius: 0;
    border-left: none;
    border-right: none;
    padding-left: 15px;
    padding-top: 15px;
    font-size: .9rem;
  }
}
.form-ask-inner {
  background-color: #fff;
  border-radius: 3px;
  position: relative;
  min-height: var(--form-height);
  overflow: hidden;
  margin-bottom: var(--answer-bottommargin);
}

@media only screen and (max-width: 767px) {
  .form-ask-inner {
    min-height: var(--form-height);
  }
}

.form-question.bigger-textarea {
  height: 120px;
}

.button-enter-active {
  transition: all 750ms cubic-bezier(0.22, 1, 0.36, 1);
}

.feedback-block-enter-active {
  transition: all 750ms cubic-bezier(0.22, 1, 0.36, 1);
}

.feedback-block-enter {
  opacity: 0;
  transform: scale(0.8);
}

.feedback-block-enter-to {
  opacity: 1;
  transform: scale(1);
}

.feedback-block-enter-active {
  transition-delay: 100ms + 600ms;
}

.button-enter {
  opacity: 0;
  transform: scale(0.8);
}

.button-enter-to {
  opacity: 1;
  transform: scale(1);
}

.button-enter-active {
  transition-delay: 200ms + 600ms;
}

.button-wrap {
  position: relative;
  overflow: hidden;
}
</style>
